import React from "react";
import { useTheme } from "@ugc-ui/lego";
import { IconsName } from "@ugc-ui/lego/components/Icon/Icon.types";
import { Nullable } from "@src/common/typings/common";
import {
  ListItemContent,
  ListItemEndIcon,
  ListItemStartIcon,
  ListItemStyled,
} from "./ListItem.styled";

export interface ListItemProps {
  children: React.ReactNode;
  isHiddenBorder?: boolean;
  startIcon?: Nullable<IconsName>;
  endIcon?: Nullable<IconsName>;
  dataCy?: string;
  color?: string;
  onClick?: () => void;
}

export const ListItem: React.FC<ListItemProps> = ({
  children,
  onClick: handleClick,
  isHiddenBorder = false,
  startIcon = null,
  endIcon = "chevron-right",
  dataCy,
  color,
}) => {
  const theme = useTheme();

  return (
    <ListItemStyled
      theme={theme}
      data-cy={dataCy}
      isHiddenBorder={isHiddenBorder}
      onClick={handleClick}
    >
      {startIcon && (
        <ListItemStartIcon icon={startIcon} color={color || theme.gray.a50} />
      )}
      <ListItemContent>{children}</ListItemContent>
      {endIcon && (
        <ListItemEndIcon icon={endIcon} color={color || theme.gray.a50} />
      )}
    </ListItemStyled>
  );
};
